module.exports = __webpack_public_path__ + "static/media/bienvenida.fc934fc4.jpg";